module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-10-Classes-Active-0c204670f9e3b73524714efa42287071.png";